<template>
  <div class="social-share">
    <div class="icon-list mt-4">
      <a :href="twitterLink" target="_blank">
        <div class="icon twitter">
          <svg width="100%" height="100%" viewBox="0 0 612 498" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><path d="M611.999,58.817c-22.525,9.981 -46.694,16.75 -72.088,19.772c25.929,-15.527 45.777,-40.155 55.184,-69.411c-24.322,14.379 -51.169,24.82 -79.775,30.48c-22.907,-24.437 -55.49,-39.658 -91.63,-39.658c-69.334,0 -125.551,56.217 -125.551,125.513c0,9.828 1.109,19.427 3.251,28.606c-104.326,-5.24 -196.835,-55.223 -258.75,-131.174c-10.823,18.51 -16.98,40.078 -16.98,63.101c0,43.559 22.181,81.993 55.835,104.479c-20.575,-0.688 -39.926,-6.348 -56.867,-15.756l0,1.568c0,60.806 43.291,111.554 100.693,123.104c-10.517,2.83 -21.607,4.398 -33.08,4.398c-8.107,0 -15.947,-0.803 -23.634,-2.333c15.985,49.907 62.336,86.199 117.253,87.194c-42.947,33.654 -97.099,53.655 -155.916,53.655c-10.134,0 -20.116,-0.612 -29.944,-1.721c55.567,35.681 121.536,56.485 192.438,56.485c230.948,0 357.188,-191.291 357.188,-357.188l-0.421,-16.253c24.666,-17.593 46.005,-39.697 62.794,-64.861Z" style="fill:#010002;fill-rule:nonzero;"/></svg>
        </div>
      </a>
      <a :href="facebookLink" target="_blank">
        <div class="icon twitter">
          <svg width="100%" height="100%" viewBox="0 0 201 431" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><path id="Facebook" d="M43.385,83.299c0,10.839 0,59.218 0,59.218l-43.385,0l0,72.412l43.385,0l0,215.183l89.122,0l0,-215.177l59.805,0c0,0 5.601,-34.721 8.316,-72.685c-7.784,0 -67.784,0 -67.784,0c0,0 0,-42.127 0,-49.511c0,-7.4 9.717,-17.354 19.321,-17.354c9.586,0 29.818,0 48.557,0c0,-9.859 0,-43.924 0,-75.385c-25.016,0 -53.476,0 -66.021,0c-93.519,-0.005 -91.316,72.479 -91.316,83.299Z" style="fill-rule:nonzero;"/></svg>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: ['textContent', 'redirectUrl'],
  data () {
    return {}
  },
  computed: {
    twitterLink () {
      return 'https://twitter.com/intent/tweet?' + 'text=' + this.textContent + '&url=https://komachi.pomzed.ch/actualites/' + this.redirectUrl + '&original_referer=' + this.redirectUrl
    },
    facebookLink () {
      return 'https://www.facebook.com/sharer/sharer.php?u=komachi.pomzed.ch/actualites/' + this.redirectUrl
    }
  }
}
</script>
<style>
.icon-list{
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-list a{
  padding: 1em;
}

.icon{}

.icon svg{
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/socials/SharedButtons.vue